module.exports = __webpack_public_path__ + "static/media/blockain only-01.b597841a.png";